import { ArrowRightOutlined, FileDoneOutlined, WarningOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  SankhyaAdmissionCollectionSerializer,
  VixtingAdmissionCollectionSerializer,
} from '../../types/api';

type CandidateIntegrationAdmissionSentProps = {
  integrationAdmissionStatus?: (
    | SankhyaAdmissionCollectionSerializer
    | VixtingAdmissionCollectionSerializer
  )['status'];
};

const CandidateIntegrationAdmissionSent = ({
  integrationAdmissionStatus,
}: CandidateIntegrationAdmissionSentProps) => {
  const { t } = useTranslation();

  if (['NEW', 'SENDING'].includes(integrationAdmissionStatus || '')) {
    return (
      <Tooltip title={t('Na fila para envio de admissão')}>
        <ArrowRightOutlined style={{ color: '#fcc903' }} />
      </Tooltip>
    );
  }
  if (integrationAdmissionStatus === 'SENT') {
    return (
      <Tooltip title={t('Enviado para Admissão')}>
        <FileDoneOutlined style={{ color: 'blue' }} />
      </Tooltip>
    );
  }
  if (integrationAdmissionStatus === 'FAILED') {
    return (
      <Tooltip title={t('Erro ao enviar para admissão')}>
        <WarningOutlined style={{ color: '#ab1423' }} />
      </Tooltip>
    );
  }
  return <></>;
};

export default CandidateIntegrationAdmissionSent;
